import { domReady } from '../helpers/DOM'
import Lazyable from '../lazyable/Lazyable'
import WebModel from '../models/WebModel'
import PrebidFacade from '../prebidFacade/PrebidFacade'
import SlotFactory from '../slots/SlotFactory'
import SlotRepository from '../slots/SlotRepository'
import { Slot } from '../slots/Slot'
export const TRIGGER_SUFFIX = 'waypoint'

/**
 * The Lazy class instantiates both slots and Lazyables
 * for every lazy slotModel received on the WebModel. It
 * is the equivalent to the ATF class for lazy slots.
 * It is NOT responsible for auctioning and displaying the
 * slot. That logic is contained in the Lazyable class.
 */
export default class Lazy {
  lazyables: Array<Lazyable> = []
  constructor(
    readonly model: WebModel,
    readonly slotFactory: SlotFactory,
    readonly prebidFacade: PrebidFacade
  ) {
    // Creates waypoints for lazy slots received from model
    domReady(() => {
      this.render()
    })
  }

  render(): void {
    for (const slotModel of this.model.slots) {
      if (!slotModel.lazy || slotModel.dynamic) {
        continue
      }

      const hintsExist =
        document.querySelectorAll(
          `.mv_slot_target[data-slot=${slotModel.type}]`
        ).length > 0
      if (hintsExist) {
        continue
      }

      // Avoid creating new Slots for adUnits that already exist.
      const slotInRepos = SlotRepository.getSlotById(slotModel.adUnitId)
      if (!slotInRepos) {
        const slot = this.slotFactory.new(slotModel)
        if (!slot || !slot.wrapper) {
          continue
        }
        this.lazyables.push(new Lazyable(slot, this.prebidFacade))
      }
    }
  }
}
